export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-refresh-0eb6b75fdcaf2441e326e58985d318ed.svg";